import _objectSpread from "D:/webproject/haoyu/wms-web/WMS/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import Cookies from "js-cookie";
var state = {
  maxScrollbar: null,
  sidebar: {
    // opened: Cookies.get("sidebarStatus") ? !!+Cookies.get("sidebarStatus") : true,
    opened: true,
    withoutAnimation: false,
    currLeftSideRoute: {}
  },
  device: "desktop",
  size: Cookies.get("size") || "medium"
};
var mutations = {
  TOGGLE_SIDEBAR: function TOGGLE_SIDEBAR(state) {
    state.sidebar.opened = !state.sidebar.opened;
    state.sidebar.withoutAnimation = false;
    if (state.sidebar.opened) {
      Cookies.set("sidebarStatus", 1);
    } else {
      Cookies.set("sidebarStatus", 0);
    }
  },
  CLOSE_SIDEBAR: function CLOSE_SIDEBAR(state, withoutAnimation) {
    Cookies.set("sidebarStatus", 0);
    state.sidebar.opened = false;
    state.sidebar.withoutAnimation = withoutAnimation;
  },
  TOGGLE_DEVICE: function TOGGLE_DEVICE(state, device) {
    state.device = device;
  },
  SET_SIZE: function SET_SIZE(state, size) {
    state.size = size;
    Cookies.set("size", size);
  },
  SET_MAXSCROLLBAR: function SET_MAXSCROLLBAR(state, el) {
    state.maxScrollbar = el;
  },
  SET_CHOOSE_SIDE_ROUTE: function SET_CHOOSE_SIDE_ROUTE(state, route) {
    state.sidebar.currLeftSideRoute = _objectSpread({}, route);
  }
};
var actions = {
  toggleSideBar: function toggleSideBar(_ref) {
    var commit = _ref.commit;
    commit("TOGGLE_SIDEBAR");
  },
  closeSideBar: function closeSideBar(_ref2, _ref3) {
    var commit = _ref2.commit;
    var withoutAnimation = _ref3.withoutAnimation;
    commit("CLOSE_SIDEBAR", withoutAnimation);
  },
  toggleDevice: function toggleDevice(_ref4, device) {
    var commit = _ref4.commit;
    commit("TOGGLE_DEVICE", device);
  },
  setSize: function setSize(_ref5, size) {
    var commit = _ref5.commit;
    commit("SET_SIZE", size);
  },
  setChooseSideRoute: function setChooseSideRoute(_ref6, route) {
    var commit = _ref6.commit;
    commit("SET_CHOOSE_SIDE_ROUTE", route);
  }
};
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};